/**
 * DASHBOARD-NPS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-nps.widget.tsx : score/emoji centrés, barres de
 * répartition (0-10) avec les 3 groupes détracteurs/neutres/promoteurs, nombre de
 * réponses, et quelques lignes "NPS par service" — avec un reflet qui balaie.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

//Hauteurs (% de la zone de tracé) rappelant la forme réelle : beaucoup de détracteurs bas,
//un pic de neutres, quelques promoteurs
const BAR_HEIGHTS = [10, 6, 10, 6, 40, 20, 55, 100, 30, 38]
const PLOT_HEIGHT = 130
const ROW_COUNT = 3

export default function DashboardNpsSkeletonWidget() {
  return (
    <div className="rel" style={{ padding: "20px 30px", overflow: "hidden" }}>
      <Skeleton width={200} height={16} style={{ marginBottom: 12 }} />
      <Skeleton width={480} height={14} style={{ marginBottom: 28 }} />

      <div className="flex items-center" style={{ gap: 24 }}>
        <div
          className="flex flex-dcol items-center"
          style={{ minHeight: 230, width: 140, justifyContent: "center" }}>
          <Skeleton width={50} height={11} style={{ marginBottom: 6 }} />
          <Skeleton width={36} height={13} style={{ marginBottom: 16 }} />
          <Skeleton width={70} height={70} isCircle style={{ marginBottom: 14 }} />
          <Skeleton width={44} height={26} />
        </div>

        <div className="flex1">
          <div className="flex items-end" style={{ gap: 8, height: PLOT_HEIGHT, marginBottom: 10 }}>
            {BAR_HEIGHTS.map((height, i) => (
              <Skeleton
                key={i}
                width={24}
                height={Math.max(10, (height / 100) * PLOT_HEIGHT)}
                borderRadius="8px 8px 0 0"
                style={{ flex: 1 }}
              />
            ))}
          </div>
          <Skeleton width="100%" height={2} style={{ marginBottom: 20 }} />
          <div className="flex" style={{ gap: 40 }}>
            <Skeleton width={90} height={13} />
            <Skeleton width={70} height={13} />
            <Skeleton width={80} height={13} />
          </div>
        </div>

        <div className="flex flex-dcol items-center" style={{ width: 110 }}>
          <Skeleton width={90} height={11} style={{ marginBottom: 6 }} />
          <Skeleton width={70} height={13} style={{ marginBottom: 12 }} />
          <Skeleton width={40} height={16} />
        </div>
      </div>

      <div style={{ marginTop: 36 }}>
        <Skeleton width={140} height={16} style={{ marginBottom: 24 }} />
        {Array.from({ length: ROW_COUNT }).map((_, i) => (
          <div key={i} className="flex items-center" style={{ gap: 20, marginBottom: 20 }}>
            <Skeleton width={140} height={13} />
            <Skeleton width={40} height={13} />
            <Skeleton width={50} height={13} />
            <div className="flex1">
              <Skeleton width="100%" height={10} borderRadius={5} />
            </div>
          </div>
        ))}
      </div>

      <SkeletonShine />
    </div>
  )
}
